module.exports = __webpack_public_path__ + "static/media/paises.e8abb648.svg";